import React, { ReactNode } from 'react'

import { Box, Table, Text } from '@factorialco/deprecated-design-system'

interface Props {
  colSpan: number
  message: string
  children?: ReactNode
}
const EmptyTableBody = ({ colSpan, message, children }: Props) => {
  return (
    <Table.Body>
      <Table.Row>
        <Table.Cell colSpan={colSpan}>
          <Box alignItems="center" justifyContent="center" padding="s16" textAlign={'center'}>
            <Text.Normal color="grey800">{message}</Text.Normal>
          </Box>
          {children && (
            <Box alignItems="center" justifyContent="center" padding="s16" textAlign={'center'}>
              {children}
            </Box>
          )}
        </Table.Cell>
      </Table.Row>
    </Table.Body>
  )
}

export default EmptyTableBody
